export default __webpack_public_path__ + "static/media/mysteryBet.f69f92ba.png";